import React from 'react';
import { useApplicationForm } from './useApplicationForm';
import StepTerms from './StepTerms';
import StepPersonal from './StepPersonal';
import StepSocial from './StepSocial';
import StepLifestyle from './StepLifestyle';
import StepCommitment from './StepCommitment';

const ApplicationForm: React.FC = () => {
  const {
    step, formData, isSubmitting, applicationsOpen, hiringCheckDone,
    termsAgreed, setTermsAgreed,
    handleChange, handleNext, handleBack, handleSubmit
  } = useApplicationForm();

  if (!hiringCheckDone) {
    return <div className="max-w-4xl mx-auto px-4 py-20 text-center text-gray-400">Loading...</div>;
  }

  if (!applicationsOpen) {
    return (
      <div className="max-w-xl mx-auto px-4 py-20 text-center">
        <div className="bg-white rounded-[2rem] shadow-xl border border-gray-100 p-12 space-y-6">
          <div className="w-16 h-16 bg-purple-100 rounded-2xl flex items-center justify-center mx-auto">
            <span className="text-3xl">🚫</span>
          </div>
          <h2 className="text-2xl font-black text-gray-900">Applications Closed</h2>
          <p className="text-gray-500 font-medium">
            We're not accepting applications right now. Check back soon!
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-4">
      <div className="text-center mb-10 space-y-4">
        <h2 className="text-4xl md:text-5xl font-black text-gray-900 tracking-tight">Join the creator program</h2>
        {step > 0 && (
          <div className="w-full bg-gray-100 h-1.5 rounded-full mt-6 overflow-hidden max-w-xs mx-auto">
            <div
              className="bg-purple-500 h-full transition-all duration-500 ease-out"
              style={{ width: `${(step / 4) * 100}%` }}
            ></div>
          </div>
        )}
      </div>

      {step === 0 && (
        <StepTerms termsAgreed={termsAgreed} onToggle={setTermsAgreed} onNext={handleNext} />
      )}

      {step > 0 && (
        <div className="bg-white rounded-[2rem] shadow-2xl border border-gray-100 overflow-hidden max-w-2xl mx-auto">
          <form className="p-8 lg:p-12">
            {step === 1 && <StepPersonal formData={formData} onChange={handleChange} onNext={handleNext} />}
            {step === 2 && <StepSocial formData={formData} onChange={handleChange} onNext={handleNext} onBack={handleBack} />}
            {step === 3 && <StepLifestyle formData={formData} onChange={handleChange} onNext={handleNext} onBack={handleBack} />}
            {step === 4 && <StepCommitment formData={formData} onChange={handleChange} onBack={handleBack} onSubmit={handleSubmit} isSubmitting={isSubmitting} />}
          </form>
        </div>
      )}
    </div>
  );
};

export default ApplicationForm;
